import { CSSProperties, ReactNode, useId } from 'react'

const IconGradientWrapper = ({
  children,
  from,
  to,
}: {
  children: ReactNode
  from: string
  to: string
}) => {
  const id = useId()
  const gradientId = `igw-${id}`
  return (
    <span
      className="relative [&_svg]:fill-(--icon-fill)"
      style={{ '--icon-fill': `url(#${gradientId})` } as CSSProperties}
    >
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient id={gradientId} x1={0} y1={0} x2={0} y2={1}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      </svg>
      {children}
    </span>
  )
}

export default IconGradientWrapper
